import {
  IMandatoryItem,
  IMandatoryItemData
} from './tariff-mandatory-item.types';

import { AbstractModel } from '@/models/base';

/**
 * A class representing model MandatoryItem.
 */
export class MandatoryItem extends AbstractModel implements IMandatoryItem {
  readonly id?: number;
  readonly item: string;

  constructor(data: IMandatoryItemData) {
    super();

    this.validate(data, ['item']);

    if (data.id) {
      this.id = data.id;
    }

    this.item = data.item!;
  }

  toString(): string {
    return this.item;
  }
}
